import { createApp } from 'vue'
import LoginApp from './LoginApp.vue'
import { initAuthTheme } from '../shared/composables/useAuthTheme.js'

const mount = document.getElementById('login-app')

if (mount) {
  initAuthTheme()

  createApp(LoginApp, {
    config: {
      guard:        mount.dataset.guard        ?? 'web',
      termsLink:    mount.dataset.termsLink    ?? '',
      privacyLink:  mount.dataset.privacyLink  ?? '',
      consentLink:  mount.dataset.consentLink  ?? '',
      registerUrl:  mount.dataset.registerUrl  ?? '',
      supportPhone: mount.dataset.supportPhone ?? '815-908-2020',
      resetToken:   mount.dataset.resetToken   ?? '',
      resetFlowMode: mount.dataset.resetFlowMode || null,
      initialFlowMode: mount.dataset.initialFlowMode || null,
      modernLoginDesignEnabled: mount.dataset.modernLoginDesignEnabled === '1',
      brandLogoUrl: mount.dataset.brandLogo    ?? document.body.dataset.brandLogo ?? '',
      magicLinkTtlMinutes: Number(mount.dataset.magicLinkTtlMinutes ?? 30),
    },
  }).mount(mount)
}
